import type { ReceiptTemplate } from '../schema';

export const sp5derTemplate: ReceiptTemplate = {
  id: 'sp5der',
  name: 'Sp5der Receipt',
  brand: 'SP5DER',
  description: 'Sp5der streetwear receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'sp5der-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'SP5DER',
        businessNameFontSize: 20,
        addressLines: [
          'ATLANTA, GA',
          'WWW.SP5DER.COM',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'sp5der-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'Order #:', value: 'SP5-847291' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'sp5der-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'SP5DER WEB HOODIE', quantity: '1', price: '450.00', sku: '' },
          { id: '2', name: 'SP5DER TRACKPANTS', quantity: '1', price: '350.00', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'sp5der-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '800.00', isBold: false, isLarge: false },
          { id: 'shipping', label: 'SHIPPING', value: '15.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '66.00', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '881.00', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'sp5der-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'sp5der-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'NO REFUNDS - EXCHANGE ONLY\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

